import { useEffect, useState } from 'react';
import { State } from '@progress/kendo-data-query';
import PopupMenu, { popupMenu as MenuList } from '../components/popupMenu';
import { PageChangeEvent, Pager } from '@progress/kendo-react-data-tools';
import {
  DefaultGridSettings,
  DefaultPagerSettings
} from '../constants/grid-settings';
import { Feedback } from '../types/feedback';

export interface CardViewDataStateChangeEvent {
  dataState: State;
}

export interface FeedbackCardViewProps extends State {
  data?: Feedback[];
  onTitlelick?: (id: number) => void;
  onCopy?: (id: number) => void;
  onView?: (id: number) => void;
  onEdit?: (id: number) => void;
  onDelete?: (id: number) => void;
  onCreateEvent?: (id: number) => void;
  onDataStateChange?: (event: CardViewDataStateChangeEvent) => void;
  total?: number;
}
export const FeedbackCardView = ({
  data,
  onTitlelick,
  onCopy,
  onView,
  onEdit,
  onDelete,
  onCreateEvent,
  total = 0,
  ...props
}: FeedbackCardViewProps) => {
  const [menuList, setMenuList] = useState<MenuList[]>([]);

  const handleTitleClick = (id: number) => {
    if (onTitlelick) {
      onTitlelick(id);
    }
  };

  const generatePopupMenu = () => {
    let newMenus: MenuList[] = [
      { classIcon: 'visibility', textMenu: 'View', textClass: '' },
      { classIcon: 'edit', textMenu: 'Edit', textClass: '' },
      { classIcon: 'content_copy', textMenu: 'Copy', textClass: '' },
      { classIcon: 'delete', textMenu: 'Delete', textClass: '' }
    ];

    setMenuList(newMenus);
  };

  const onMenuSelected = (id: number, menu: MenuList) => {
    if (!id) return;

    if (menu.textMenu === 'Copy') {
      if (onCopy) {
        onCopy(id);
      }
    }
    if (menu.textMenu === 'View') {
      if (onView) {
        onView(id);
      }
    }
    if (menu.textMenu === 'Create Event') {
      if (onCreateEvent) {
        onCreateEvent(id);
      }
    }
    if (menu.textMenu === 'Delete') {
      if (onDelete) {
        onDelete(id);
      }
    }
    if (menu.textMenu === 'Edit') {
      if (onEdit) {
        onEdit(id);
      }
    }
  };

  const handlePageChange = (event: PageChangeEvent) => {
    raiseDataStateChangeEvent({ skip: event.skip, take: event.take });
  };

  /**
   * Raise the Grid DataState change event. I.e. filters have changed.
   * @param moreData
   */
  const raiseDataStateChangeEvent = (moreData: State) => {
    props.onDataStateChange?.({
      dataState: { ...getDataState(), ...moreData }
    });
  };

  const getDataState = () => {
    return {
      filter: props.filter,
      sort: props.sort,
      skip: props.skip,
      take:
        props.take !== undefined ? props.take : DefaultGridSettings.pageSize,
      group: props.group
    };
  };

  const StatusName = (status: string) => {
    if (status === 'Approved') {
      return 'Published/Global Library';
    } else if (status === 'New') {
      return 'Draft';
    } else if (status === 'Rejected') {
      return 'Published';
    } else if (status === 'Pending') {
      return 'Published/Submitted';
    } else {
      return status;
    }
  };

  useEffect(() => {
    generatePopupMenu();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
        overflow: 'hidden'
      }}>
      <div
        className={'row grid-card-library'}
        style={{
          flexGrow: 1,
          overflow: 'auto'
        }}>
        {data &&
          data.map((lib, index) => {
            return (
              <div
                className={'col-xs-12 col-sm-12 col-md-6 d-flex'}
                key={index}>
                <div className={'card mt-4 card-view card-library flex-grow-1'}>
                  <div className={'row p-3'}>
                    <div className={'col-3'}>
                      <div
                        className={`avatar ${
                          Boolean(lib.logoUrl) ? 'bg-white' : 'bg-primary'
                        }`}>
                        {Boolean(lib.logoUrl) ? (
                          <img
                            className={'w-100 h-100 rounded-full'}
                            src={lib.logoUrl}
                            alt="logo"
                          />
                        ) : (
                          <i className={'bi bi-person icon'} />
                        )}
                      </div>
                    </div>
                    <div className={'col-9'}>
                      <div className={'card-body-right p-2'}>
                        <div
                          className={
                            'd-flex justify-content-between align-items-center'
                          }>
                          <h3
                            className={'title stretched-link'}
                            onClick={() => handleTitleClick(lib.id!)}
                            role={'button'}>
                            {' '}
                            {lib?.name}
                          </h3>
                          <PopupMenu
                            menus={menuList}
                            id={lib.id!}
                            onMenuSelected={onMenuSelected}></PopupMenu>
                        </div>
                        <hr className={'mt-0'} />

                        <div className={'d-flex flex-wrap'}>
                          <div> Creator : </div>
                          <div className="text-success">
                            {'\u00A0' + (lib.createdBy ? lib.createdBy : '')}
                          </div>
                        </div>
                        <div className={'d-flex flex-wrap'}>
                          <div> Status :</div>
                          <div className={'ml-1 text-success'}>
                            {StatusName(lib?.status!)}
                          </div>
                        </div>
                        <div className={'d-flex flex-wrap'}>
                          <div> Source : </div>
                          <div className="ml-1 text-success"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className={'row mt-3'}>
        <div className={'col-md-12'}>
          <Pager
            onPageChange={handlePageChange}
            total={total}
            take={
              props.take !== undefined
                ? props.take
                : DefaultGridSettings.pageSize
            }
            skip={props.skip !== undefined ? props.skip : 0}
            {...DefaultPagerSettings}
          />
        </div>
      </div>
    </div>
  );
};
